import { RootState } from 'lib/core/data/reducer'
import { createSelector } from '@reduxjs/toolkit'
import { ERROR } from 'lib/core/resources/constants'

export const getSlice = (state: RootState) => {
  return state.customer.createCustomer
}

export const getError = createSelector(
  getSlice,
  (slice) => {
    if (slice.isFailure) {
      if (slice.errors?.length) {
        const messages = slice.errors.map(message => message).join(';')
        if (messages.includes(ERROR.CUSTOMER_EXISTS)) {
          return 'customer.account.create.error.customerExists'
        }
      }
      return 'app.whoops'
    }
  }
)
